// extracted by mini-css-extract-plugin
export default {"Mentor":"Mentor_Mentor__OYaz6","Text":"Mentor_Text__Bw6p0","Photo":"Mentor_Photo__lMeN2"};